import { render, staticRenderFns } from "./FooterView.vue?vue&type=template&id=37dccd31&scoped=true&"
import script from "./FooterView.vue?vue&type=script&lang=js&"
export * from "./FooterView.vue?vue&type=script&lang=js&"
import style0 from "./FooterView.vue?vue&type=style&index=0&id=37dccd31&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../WebApp_Client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37dccd31",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../WebApp_Client/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
